import RenderDebuggerService from '@/api/admin/renderDebugger.service'

export default {
  state: {
    ads: {},
  },
  getters: {
    getAds: state => state.ads,
  },
  actions: {
    async getRenderAds({ commit }, searchTerm = '') {
      const ads = await RenderDebuggerService.getAds(searchTerm)
      commit('SET_ADS', ads)
    },
  },
  mutations: {
    SET_ADS(state, ads) {
      state.ads = ads
    },
  },
}
